enum TipoBuscaMovimentacao {
    Lote = 1,
    Produto = 2,
}

export default TipoBuscaMovimentacao;
